export enum MatterDetailStatus {
  MattersLoading = 'matters-loading',
  MattersError = 'matters-error',
  NotFound = 'not-found',
  NoAccess = 'no-access',
  RedirectStripe = 'redirect-stripe',
  Ready = 'ready',
}
